import React, { useState, useEffect } from 'react';
import i18next from 'core/i18n';
import { DialogContent, Textarea, useFlashMessage } from '@indigo-ag/component-module';

import { EnhancedDialog, INotes, ModalActionButtons } from 'shared';
import { Credit } from '@indigo-ag/schema';

export interface NotesModalProps {
  closeModal: () => void;
  open: boolean;
  notesSectionInfo?: INotes;
  updateCredit: (newCreditInfo: Partial<Credit>) => Promise<unknown>;
}

export const NotesModal: React.FunctionComponent<NotesModalProps> = ({
  closeModal,
  open,
  notesSectionInfo,
  updateCredit
}) => {
  /**
   * State
   */
  const [opinion, setOpinion] = useState<INotes>({
    creditOpinion: notesSectionInfo?.creditOpinion ?? '',
    legalOpinion: notesSectionInfo?.legalOpinion ?? ''
  });

  useEffect(() => {
    setOpinion({
      creditOpinion: notesSectionInfo?.creditOpinion,
      legalOpinion: notesSectionInfo?.legalOpinion
    });
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const textHandler = (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
    setOpinion({ ...opinion, [event.target.name]: event.target.value });
  };

  const { addFlashMessage } = useFlashMessage();

  const updateInfo = () => {
    return updateCredit({
      ...opinion
    }).then(() => {
      addFlashMessage({
        content: `${i18next.t('notes')} ${i18next.t('hasBeenUpdatedSuccessfully')}`,
        title: '',
        variant: 'success'
      });
    });
  };

  return (
    <EnhancedDialog open={open} title={i18next.t('notes')} onClose={closeModal}>
      <DialogContent>
        <Textarea
          label={i18next.t('creditOpinion')}
          name={'creditOpinion'}
          value={opinion.creditOpinion}
          onChange={textHandler}
          resizable
          rows={3}
        />
        <Textarea
          label={i18next.t('legalOpinion')}
          name={'legalOpinion'}
          value={opinion.legalOpinion}
          onChange={textHandler}
          resizable
          rows={3}
        />
      </DialogContent>
      <ModalActionButtons
        changeButtonName={i18next.t('saveChanges')}
        closeModal={closeModal}
        disabled={!opinion.legalOpinion && !opinion.creditOpinion}
        save={updateInfo}
      />
    </EnhancedDialog>
  );
};
